// extracted by mini-css-extract-plugin
export default {"Work":"Work_Work__huhif","slide-in":"Work_slide-in__zCYQJ","Heading":"Work_Heading__JQ1kZ","Description":"Work_Description__63ngN"};